export default {
	window_size: state => {
		return state.window_size
	},
	icmywealth: state => {
		return state.icmywealth
	},
	user: state => {
		return state.user
	},
	company: state => {
		return state.company
	},
	userFullname: state => {
		return state.user.name
	},
	contact_subjects: state => {
		return state.contact_subjects
	},
	notification_types: state => {
		return state.notification_types
	},
	currencies: state => (locale = false) => {
		if (locale) {
			return state.currencies_locale
		}
		return state.currencies
	},
	transaction_types: state => {
		return state.transaction_types
	},
	fee_statuses: state => {
		return state.fee_statuses
	},
	message_topics: state => {
		return state.message_topics
	},
	message_subjects: state => {
		return state.message_subjects
	},
	identificationTypes: state => {
		return state.identification_types
	},
	month_days: state => {
		return state.month_days
	},
	document_types: state => {
		return state.document_types
	},
	paymentServices: state => {
		return state.paymentServices
	},
	paymentTypes: state => {
		return state.paymentTypes
	},
	policyTypes: state => state.policyTypes,
	countries: state => state.countries,
	cities: state => state.cities,
	activePaymentTypes: state => {
		return state.paymentTypes.filter(paymentType => paymentType.active)
	},
	getIcGroupBankAccountByType: state => type => {
		return state.icgroup.bank_accounts[type]
	}
}
